import { ReactComponent as FlagIcon } from "./svg/kg-flag.svg";
import "../flag-icon.scss";

export const KGFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
